// 参数管理
export class TabParam {
  constructor() {
    this.Page = { // 分页参数
      pageNo: 1,
      pageSize: 10,
      total: 0
    }
    this.listQuery = { // 查询参数
      tname: undefined, // 标准名称
      startPlace: undefined, // 起运地
      stopPlace: undefined, // 目的地
      standardLoadStart: undefined, // 标准载重起
      standardLoadEnd: undefined // 标准载重止
    }
    this.editType = [{
      label: '司机姓名',
      type: 'text',
      prop: 'tname'
    }, {
      label: '联系电话',
      type: 'text',
      prop: 'startPlace'
    }]
    /**
         * 表格头
         * 属性：table-head
         * 类型：Array
         * lable: 显示的名称
         * prop: 数据字段
         * type: 类型 比如序号
         * header-align: 表头对齐方式 left/center/right
         * align: 内容对齐方式 left/center/right
         * sortable: 是否可以排序 true/false
         * width: 对应列的宽度 Number
         * min-width: 对小宽度
         */
    this.tableHead = [
      {
        label: '司机姓名',
        prop: 'tname',
        align: 'center',
        sortable: false,
        slot: 'sjxm'
      },
      {
        label: '身份证号',
        prop: 'cardNoId',
        align: 'center',
        sortable: false
      },
      {
        label: '性别',
        prop: 'startPlace',
        align: 'center',
        sortable: false
      },
      {
        label: '驾照等级',
        prop: 'stopPlace',
        align: 'center',
        sortable: false
      },
      {
        label: '年龄',
        prop: 'standardLoad',
        align: 'center',
        sortable: false
      },
      {
        label: '联系电话',
        prop: 'standardFuel',
        align: 'center',
        sortable: false
      },
      {
        label: '驾驶证号',
        prop: 'money',
        align: 'center',
        sortable: false
      },
      {
        label: '驾驶证图片',
        prop: 'fuelName',
        align: 'center',
        sortable: false,
        slot: 'operation'
      },
      {
        label: '备注',
        prop: 'fuelName',
        align: 'center',
        sortable: false
      }
    ]
    this.tableButKey = {
      /**
         * 操作栏
         * 编辑 -- edit
         * 删除 -- del
         * 打印 -- dy
         * 查看 -- see
         */
      btn: []
    }
  }
    Page;
    listQuery;
    tableHead;
    tableButKey;
}

export class FormParam {
  constructor() {
    this.dataForm = {
      // from表单参数
      driver1: '', // 标准名称
      driver2: '', // 车牌号
      driver3: '', // 始发地
      driver4: '', // 目的地
      driver5: '', // 标准载重
      driver6: '', // 标准耗油
      driver7: '', // 提成工资
      driver8: '', // 计算规则
      driver9: '' // 计算规则
    }
    this.rules = {
      // 表单提交校验
      radioGroup: [
        { required: true, message: '请至少选择一项', trigger: 'change' }
      ],
      demandArea: [
        { required: true, message: '请输入需求面积', trigger: 'blur' },
        { min: 2, max: 6, message: '长度在 2 到 6 个字符', trigger: 'blur' }
      ],
      enterpriseName: [
        { required: true, message: '请输入公司名称', trigger: 'blur' }
      ],
      companyContacts: [
        { required: true, message: '请输入公司联系人', trigger: 'blur' }
      ],
      telephone: [
        { required: true, message: '请输入联系电话', trigger: 'blur' }
      ]
    }
  }
    dataForm;
    rules;
}

export class tableClass {
  constructor() {
    this.table = null
    this.form = null
  }

  // 调用列表参数
  static getTable() {
    if (!this.table) {
      this.table = new TabParam()
    }
    return this.table
  }

  // 调用表单参数
  static getForm() {
    if (!this.form) {
      this.form = new FormParam()
    }
    return this.form
  }
}
